import { observable, action } from "mobx";

class DeepResearchStepPopupState {
  @observable showPopup = false;
  @observable popupValues = {};

  @action
  setShowPopup = (value) => {
    this.showPopup = value;
  };

  @action
  setPopupValues = (values) => {
    this.popupValues = values || {};
  };

  @action
  reset = () => {
    this.showPopup = false;
    this.popupValues = {};
  };
}

const deepResearchStepPopupState = new DeepResearchStepPopupState();
export { deepResearchStepPopupState };
export default deepResearchStepPopupState;
